/* ESFARI: make the Judge.me verified badge a crawlable link to the existing reviews page.
   No review data or app blocks are changed. */
(function () {
  var destination = '/pages/reviews';
  var selector = 'a.jdgm-verified-count-badget';
  function fixBadges(root) {
    (root || document).querySelectorAll(selector).forEach(function (link) {
      if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
      if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
        link.setAttribute('aria-label', 'Bekijk geverifieerde klantbeoordelingen van ESFARI');
      }
    });
  }
  function init() {
    fixBadges(document);
    // Judge.me may insert its badge after DOMContentLoaded.
    var observer = new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        return change.type === 'childList' || (change.type === 'attributes' && change.attributeName === 'href');
      })) fixBadges(document);
    });
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  // The badge is an actual navigation link, even if the embedded app attaches a click handler.
  document.addEventListener('click', function (event) {
    var badge = event.target.closest && event.target.closest(selector);
    if (!badge || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.stopImmediatePropagation();
    window.location.assign(destination);
  }, true);
})();
